module.exports = __webpack_public_path__ + "img/step1.03b5fa3b.png";